import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvService {
  private readonly apiRoots = new Map<ApiRoot, string>();

  constructor() {
    this.apiRoots.set(ApiRoot.Core, environment.webAPIRoots.core);
  }

  get api() {
    return api;
  }

  getWebAPIRoot(apiRoot: ApiRoot): string {
    const requestedApiRoot = this.apiRoots.get(apiRoot);
    if (requestedApiRoot === undefined) {
      throw new Error(`ApiRoot '${ApiRoot[apiRoot]}' not recognized`);
    }

    return requestedApiRoot;
  }

  get assetsFolderPath() {
    return environment.assetsFolderPath;
  }

  get imagesFolderPath() {
    return environment.assetsFolderPath + 'images/';
  }

  get appInsightInstrumentationKey() {
    return environment.appInsights.instrumentationKey;
  }

  get isProduction() {
    return environment.environmentName === 'Production';
  }

  get isDevelopment() {
    return environment.environmentName === 'Development';
  }

  get allowAppInsightLog() {
    return environment.allowAppInsightLog;
  }

  get pdfConcurrencyDownloads() {
    return environment.pdfConcurrency.downloads;
  }

  get pdfConcurrencyThumbnails() {
    return environment.pdfConcurrency.thumbnails;
  }
}

export enum ApiRoot {
  Core,
}

export const api = {
  emails: {
    getEmails: '/emails',
    getEmailCarriers: '/email-carriers',
    getEmailAttachments: (emailId: number) => `/email/${emailId}/attachments`,
    getEmailAttachmentPages: (urlEncodedAttachmentMd5: string, pageName: string) => `/attachments/${urlEncodedAttachmentMd5}/pages/${pageName}`,
    getEmailPreview: (emailId: bigint) => `/email/${emailId}/preview`,
    getUpdateState: (id: number) => `/emails/${id}/state`,
    commitState: (id: number) => `/emails/${id}/state/commit`,
    ignoreEmail: (id: number) => `/emails/${id}/state/ignore`,
    bulkIgnoreEmails: '/emails/state/bulk-ignore',
    getLatestAvailableEmail: '/email/latest',
  },
  email_locking: {
    getEmailLockOwner: (emailId: number) => `/emails/${emailId}/lock-owner`,
    lockEmail: (emailId: number) => `/emails/${emailId}/lock`,
    unlockEmail: (emailId: number) => `/emails/${emailId}/unlock`,
  },
  documents: {
    getDocumentTypes: '/documents/types',
  },
  shipments: {
    getShipmentCarriers: (shipmentId: number) => `/shipments/${shipmentId}/carriers`,
    getShipmentDetails: (shipmentId: number) => `/shipments/${shipmentId}/details`,
    getShipmentDocuments: (shipmentId: number, supplierLocationId: number) => `/shipments/${shipmentId}/suppliers/${supplierLocationId}/documents`,
    getShipmentFirstPickLastDrop: (shipmentId: number, supplierLocationId: number) =>
      `/shipments/${shipmentId}/suppliers/${supplierLocationId}/first-pick-last-drop`,
  },
  secrets: {
    getSecret: (secretName: string) => `/secrets/${secretName}`,
  },
  system: {
    login: `${environment.webAPIRoots.core}/login`,
  },
  user_activity: {
    getUserActivities: (emailId: number) => `/emails/${emailId}/user-activities`,
    addUserActivity: (emailId: number) => `/emails/${emailId}/user-activity`,
  },
};
